// in Proteus - file still used for DOTD & Outlet

function recaptcha4i() {
	var executeRecaptcha = function (siteKey, actionName, callback) {
		grecaptcha.execute(siteKey, { action: actionName })
			.then(function (token) {
				callback(token);
			});
	};

	// Accessibility changes to the HTML generated by Google
	var logo = document.getElementsByClassName('grecaptcha-logo');
	if (logo.length > 0) {
		var logoIframe = logo[0].getElementsByTagName('iframe');
		if (logoIframe.length > 0) {
			// Adds title to iframe
			logoIframe[0].setAttribute('title', 'Google reCAPTCHA Logo');
			// Hides iframe from screen readers
			logoIframe[0].setAttribute('hidden', 'true');
		}
	}

	// Adds label to reCAPTCHA response textarea
	var response = document.getElementById('g-recaptcha-response-100000');
	if (response) {
		response.setAttribute('aria-label', 'reCAPTCHA response');
	}

	// wire up any forms needing recaptcha
	var recaptchaForms = document.getElementsByClassName('recaptchaForm');
	for (var i = 0; i < recaptchaForms.length; i++) {
		var rForm = recaptchaForms[i];
		var rSiteKey;
		var siteKeyElements = rForm.getElementsByClassName('recaptchaSiteKey');
		if (siteKeyElements.length > 0) {
			rSiteKey = siteKeyElements[0].value;
		} else {
			console.error("recaptchaSiteKey element not found in form");
			return; // Exit the function if the element is not found
		}
		var actionNameElements = rForm.getElementsByClassName('recaptchaActionName');
		var rActionName;
		if (actionNameElements.length > 0) {
			rActionName = actionNameElements[0].value;
		} else {
			console.error("recaptchaActionName element not found in form");
			return; // Exit the function if the element is not found
		}

		rForm.onsubmit = function (e) {
			e.preventDefault();
			executeRecaptcha(rSiteKey, rActionName, function (token) {
				rForm.getElementsByClassName('recaptchaToken')[0].value = token;
				rForm.submit();
			});
		};
	}
}

function get4iRecaptcha() {
	// Get the key for the recaptcha script
	let retryCount = 0;
	const maxRetries = 3;

	function tryFetchSiteKey() {
		fetch('/header/recaptchasitekey', { method: 'POST', headers: { 'X-Requested-With': 'fetch' } })
			.then(function (response) {
				if (response.ok) {
					return response.json();
				} else {
					return Promise.reject(); // Prevent further .then execution
				}
			})
			.then(function (json) {
				if (!json || !json.siteKey || json.siteKey.length < 1) {
					console.error("Failed to retrieve recaptchasitekey, trying backup");
					handleBackupSiteKey();
					return;
				}
				var recapEl = document.createElement('script');
				recapEl.type = 'text/javascript';
				recapEl.async = true;
				recapEl.src = 'https://www.google.com/recaptcha/api.js?render=' + json.siteKey + '&onload=recaptcha4i'; // onload bit invokes the code above after the JS finishes loading
				var capBod = document.getElementsByTagName('body')[0];
				capBod.appendChild(recapEl);
			})
			.catch(function (error) {
				retryCount++;

				if (error) {
					console.error('Error processing recaptcha request, retrying... Retry Count: ' + retryCount);
				} else {
					console.error('Failed fetching recaptcha site key, retrying... Retry Count: ' + retryCount);
				}

				if (retryCount < maxRetries) {
					tryFetchSiteKey();
				} else {
					handleBackupSiteKey();
				}
			});
	}

	function handleBackupSiteKey() {
		let siteKey = '';

		var backup = document.getElementById('backupgrecaptcha');
		if (backup) siteKey = backup.value;

		if (!siteKey || siteKey.length < 1 || siteKey == '') {
			console.error("Failed to retrieve backup recaptchasitekey");
			return;
		}

		var recapEl = document.createElement('script');
		recapEl.type = 'text/javascript';
		recapEl.async = true;
		recapEl.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey + '&onload=recaptcha4i'; // onload bit invokes the code above after the JS finishes loading
		var capBod = document.getElementsByTagName('body')[0];
		capBod.appendChild(recapEl);
	}

	tryFetchSiteKey();
}

(function () {
	get4iRecaptcha();
})();